module.exports = __webpack_public_path__ + "media/components/theme/fonts/GTPressuraMono-869bfcfc90f440186a9efae688448975.woff2";